<script setup>
import CFBadge from '@/ui/Badge/CFBadge.vue';
import { computed } from 'vue';
import CFIcon from '@/ui/Icon/CFIcon.vue';
import { SupportStatus } from '#modules/support/models/SupportStatus.js';

const props = defineProps({
    ticket: {
        type: Object,
        required: true,
    },
    isActive: {
        type: Boolean,
        required: true,
    },
});

const hasUnreadMessages = computed(() => {
    return props.ticket.attributes.read_at === null;
});

const badgeColor = computed(() => {
    if (props.ticket.attributes.status === SupportStatus.WaitingForUser) {
        return 'success';
    }

    if (props.ticket.attributes.status === SupportStatus.WaitingForCyberfusion) {
        return 'info';
    }

    return 'warning';
});
</script>

<template>
    <button
        type="button"
        class="relative block w-full cursor-pointer border-b border-black px-3 py-5 text-left wrap-break-word transition-all ease-in"
        :class="{
            'bg-neutrals-400': isActive,
            'hover:bg-neutrals-400/75': !isActive,
            'pr-7!': hasUnreadMessages,
        }"
    >
        <span class="block truncate text-sm font-bold">{{ ticket.attributes.subject }}</span>
        <span
            v-if="ticket.attributes.number"
            class="text-neutrals-700 block truncate text-sm"
        >
            #{{ ticket.attributes.number }}
        </span>
        <span class="mt-1 flex items-center gap-2">
            <CFBadge
                :color="badgeColor"
                size="xs"
                class="truncate"
            >
                {{ $t(`support.statuses.${ticket.attributes.status}`) }}
            </CFBadge>
            <span class="text-neutrals-700 inline-flex items-center gap-1 text-sm lowercase">
                <CFIcon
                    name="messages-bubble"
                    class="size-3.5"
                />
                {{ ticket.attributes.messages_count }}
            </span>
        </span>

        <Transition name="fade">
            <span
                v-if="hasUnreadMessages"
                class="bg-pink-gradient absolute top-1/2 right-3 size-2 -translate-y-1/2 transform rounded-full"
            />
        </Transition>
    </button>
</template>
